export default __webpack_public_path__ + "static/media/property_mx.6cd0468d.png";